var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"target":_vm.refId,"show":_vm.show,"placement":"bottom"},on:{"update:show":function($event){_vm.show=$event}}},[_vm._v(_vm._s(_vm.FormMSG(1, 'Some of timesheet details are out of contract.')))])
}
var staticRenderFns = []

export { render, staticRenderFns }